import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function PageShell({ children, testid }) {
  return (
    <div className="min-h-screen bg-[#0A0908] text-[#F5EFE0] grain" data-testid={testid}>
      <Header />
      <main className="pt-[74px]">{children}</main>
      <Footer />
    </div>
  );
}
